'use client';
import React, { useEffect, useState } from 'react';
import {
  Box,
  Heading,
  Flex,
  Link,
  Text,
  Divider,
  useBreakpointValue,
} from '@chakra-ui/react';

export default function ExploreMenu({ secContent }) {

  let [sectionContent, setSectionContent] = useState([])

  useEffect(() => {
    if (typeof window != undefined){
      let secToUpdate = []
      for (let index = 0; index < secContent?.length; index++) {
        let element = secContent[index];
        if(!window?.location?.href?.includes(element.linkUrl)){
          secToUpdate.push(element)
        }        
      } 
      setSectionContent([...secToUpdate])
    }
  }, [secContent])
  

  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Box
      bgColor="#FFF"
      width="100%"
      py={{ base: '3.5rem', lg: '5rem' }}
      display={'flex'}
      justifyContent={{ base: 'flex-start', lg: 'center' }}
      px={{ base: '1.1rem', lg: '0px' }}
    >
      <Box
        width={{ base: '100%', md: "100%", xl: '1169px' }}
      >
        <Text
          color="#B7870C"
          fontFamily="var(--AustinMedium)"
          fontWeight={500}
          fontSize={{ base: "34px", md: "60px" }}
          lineHeight={{ base: '36px', md: '60px' }}
          mb={{ base: '1rem', 'md': '2rem' }}
        >
          {sectionContent?.[0]?.text}
        </Text>

        <Flex
          direction={{ base: "column", md: "row" }}
          justifyContent={'space-between'}
          width={'100%'}
          alignItems={'center'}
        >
          {sectionContent.map((link, idx) => {
            if(idx/1 == 0){
              return null
            }            
            return (
            <React.Fragment key={link.buttonText}>
              <Link
                fontFamily={'FedraSansStd-book'}
                href={link.linkUrl}
                display="flex"
                color="#030040"
                fontWeight={500}
                fontSize={{ base: "18px", md: "20px" }}
                width={{ base: '100%', md: 'auto' }}
                borderBottom={{ base: idx < sectionContent.length - 1 ? '1px solid #000000' : 'none', md: 'none' }}
                py={'1rem'}
              >
                <Text>{link.buttonText}
                </Text>
                <span style={{ marginTop: '0.5rem', marginLeft: isMobile ? 'auto' : '1.2rem', marginRight: isMobile ? '0.8rem' : undefined }}>
                  <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.16699 13.6668L7.83366 8.00016L2.16699 2.3335" stroke="#B7870C" stroke-width="2.83333" stroke-linecap="square" />
                  </svg>
                </span>
              </Link>
              {idx < sectionContent.length - 1 && !isMobile && (
                <Divider
                  orientation="vertical"
                  height="54px"
                  borderColor="#000000"
                />
              )}
            </React.Fragment>
          )})}
        </Flex>
      </Box>
    </Box>
  );
}
